/**
 * Do not edit directly
 * Generated on Sun, 17 Jul 2022 21:43:32 GMT
 */

module.exports = {
  '-ds-core-100': {
    value: '#F9F5F2',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F9F5F2',
    },
    name: 'DsCore100',
    attributes: {
      category: '-ds-core-100',
    },
    path: ['-ds-core-100'],
  },
  '-ds-core-200': {
    value: '#FEC077',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FEC077',
    },
    name: 'DsCore200',
    attributes: {
      category: '-ds-core-200',
    },
    path: ['-ds-core-200'],
  },
  '-ds-core-300': {
    value: '#0C393F',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#0C393F',
    },
    name: 'DsCore300',
    attributes: {
      category: '-ds-core-300',
    },
    path: ['-ds-core-300'],
  },
  '-ds-core-400': {
    value: '#0C6776',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#0C6776',
    },
    name: 'DsCore400',
    attributes: {
      category: '-ds-core-400',
    },
    path: ['-ds-core-400'],
  },
  '-ds-core-50': {
    value: '#FFF5F0',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FFF5F0',
    },
    name: 'DsCore50',
    attributes: {
      category: '-ds-core-50',
    },
    path: ['-ds-core-50'],
  },
  '-ds-error-100': {
    value: '#FCF5F6',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FCF5F6',
    },
    name: 'DsError100',
    attributes: {
      category: '-ds-error-100',
    },
    path: ['-ds-error-100'],
  },
  '-ds-error-200': {
    value: '#FA9E9E',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FA9E9E',
    },
    name: 'DsError200',
    attributes: {
      category: '-ds-error-200',
    },
    path: ['-ds-error-200'],
  },
  '-ds-error-300': {
    value: '#AB000D',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#AB000D',
    },
    name: 'DsError300',
    attributes: {
      category: '-ds-error-300',
    },
    path: ['-ds-error-300'],
  },
  '-ds-information-100': {
    value: '#F7F8FA',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F7F8FA',
    },
    name: 'DsInformation100',
    attributes: {
      category: '-ds-information-100',
    },
    path: ['-ds-information-100'],
  },
  '-ds-information-200': {
    value: '#B1B9E3',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#B1B9E3',
    },
    name: 'DsInformation200',
    attributes: {
      category: '-ds-information-200',
    },
    path: ['-ds-information-200'],
  },
  '-ds-information-300': {
    value: '#3E4A7C',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#3E4A7C',
    },
    name: 'DsInformation300',
    attributes: {
      category: '-ds-information-300',
    },
    path: ['-ds-information-300'],
  },
  '-ds-neutral-100': {
    value: '#FFFFFF',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FFFFFF',
    },
    name: 'DsNeutral100',
    attributes: {
      category: '-ds-neutral-100',
    },
    path: ['-ds-neutral-100'],
  },
  '-ds-neutral-200': {
    value: '#F7F8F6',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F7F8F6',
    },
    name: 'DsNeutral200',
    attributes: {
      category: '-ds-neutral-200',
    },
    path: ['-ds-neutral-200'],
  },
  '-ds-neutral-300': {
    value: '#CBCCCB',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#CBCCCB',
    },
    name: 'DsNeutral300',
    attributes: {
      category: '-ds-neutral-300',
    },
    path: ['-ds-neutral-300'],
  },
  '-ds-neutral-400': {
    value: '#A0A09F',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#A0A09F',
    },
    name: 'DsNeutral400',
    attributes: {
      category: '-ds-neutral-400',
    },
    path: ['-ds-neutral-400'],
  },
  '-ds-neutral-500': {
    value: '#767676',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#767676',
    },
    name: 'DsNeutral500',
    attributes: {
      category: '-ds-neutral-500',
    },
    path: ['-ds-neutral-500'],
  },
  '-ds-neutral-600': {
    value: '#494948',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#494948',
    },
    name: 'DsNeutral600',
    attributes: {
      category: '-ds-neutral-600',
    },
    path: ['-ds-neutral-600'],
  },
  '-ds-neutral-700': {
    value: '#1D1D1D',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#1D1D1D',
    },
    name: 'DsNeutral700',
    attributes: {
      category: '-ds-neutral-700',
    },
    path: ['-ds-neutral-700'],
  },
  '-ds-success-100': {
    value: '#F5F8F8',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#F5F8F8',
    },
    name: 'DsSuccess100',
    attributes: {
      category: '-ds-success-100',
    },
    path: ['-ds-success-100'],
  },
  '-ds-success-200': {
    value: '#91C4BD',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#91C4BD',
    },
    name: 'DsSuccess200',
    attributes: {
      category: '-ds-success-200',
    },
    path: ['-ds-success-200'],
  },
  '-ds-success-300': {
    value: '#0A4E45',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#0A4E45',
    },
    name: 'DsSuccess300',
    attributes: {
      category: '-ds-success-300',
    },
    path: ['-ds-success-300'],
  },
  '-ds-warning-100': {
    value: '#FCF6F5',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FCF6F5',
    },
    name: 'DsWarning100',
    attributes: {
      category: '-ds-warning-100',
    },
    path: ['-ds-warning-100'],
  },
  '-ds-warning-200': {
    value: '#FFBC97',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#FFBC97',
    },
    name: 'DsWarning200',
    attributes: {
      category: '-ds-warning-200',
    },
    path: ['-ds-warning-200'],
  },
  '-ds-warning-300': {
    value: '#A12001',
    filePath: './style-dictionary/tokens/token.json',
    isSource: true,
    original: {
      value: '#A12001',
    },
    name: 'DsWarning300',
    attributes: {
      category: '-ds-warning-300',
    },
    path: ['-ds-warning-300'],
  },
  '-ds-font-size-lg': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      },
      name: 'DsFontSizeLgFontFamily',
      attributes: {
        category: '-ds-font-size-lg',
        type: 'font-family',
      },
      path: ['-ds-font-size-lg', 'font-family'],
    },
    'font-size': {
      value: '24px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '24px',
      },
      name: 'DsFontSizeLgFontSize',
      attributes: {
        category: '-ds-font-size-lg',
        type: 'font-size',
      },
      path: ['-ds-font-size-lg', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeLgLetterSpacing',
      attributes: {
        category: '-ds-font-size-lg',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-lg', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeLgLineHeight',
      attributes: {
        category: '-ds-font-size-lg',
        type: 'line-height',
      },
      path: ['-ds-font-size-lg', 'line-height'],
    },
    'font-weight': {
      value: '300',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '300',
      },
      name: 'DsFontSizeLgFontWeight',
      attributes: {
        category: '-ds-font-size-lg',
        type: 'font-weight',
      },
      path: ['-ds-font-size-lg', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeLgColor',
      attributes: {
        category: '-ds-font-size-lg',
        type: 'color',
      },
      path: ['-ds-font-size-lg', 'color'],
    },
  },
  '-ds-font-size-md': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Regular'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Regular'",
      },
      name: 'DsFontSizeMdFontFamily',
      attributes: {
        category: '-ds-font-size-md',
        type: 'font-family',
      },
      path: ['-ds-font-size-md', 'font-family'],
    },
    'font-size': {
      value: '20px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '20px',
      },
      name: 'DsFontSizeMdFontSize',
      attributes: {
        category: '-ds-font-size-md',
        type: 'font-size',
      },
      path: ['-ds-font-size-md', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeMdLetterSpacing',
      attributes: {
        category: '-ds-font-size-md',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-md', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeMdLineHeight',
      attributes: {
        category: '-ds-font-size-md',
        type: 'line-height',
      },
      path: ['-ds-font-size-md', 'line-height'],
    },
    'font-weight': {
      value: '400',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '400',
      },
      name: 'DsFontSizeMdFontWeight',
      attributes: {
        category: '-ds-font-size-md',
        type: 'font-weight',
      },
      path: ['-ds-font-size-md', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeMdColor',
      attributes: {
        category: '-ds-font-size-md',
        type: 'color',
      },
      path: ['-ds-font-size-md', 'color'],
    },
  },
  '-ds-font-size-sm': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      },
      name: 'DsFontSizeSmFontFamily',
      attributes: {
        category: '-ds-font-size-sm',
        type: 'font-family',
      },
      path: ['-ds-font-size-sm', 'font-family'],
    },
    'font-size': {
      value: '18px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '18px',
      },
      name: 'DsFontSizeSmFontSize',
      attributes: {
        category: '-ds-font-size-sm',
        type: 'font-size',
      },
      path: ['-ds-font-size-sm', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeSmLetterSpacing',
      attributes: {
        category: '-ds-font-size-sm',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-sm', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeSmLineHeight',
      attributes: {
        category: '-ds-font-size-sm',
        type: 'line-height',
      },
      path: ['-ds-font-size-sm', 'line-height'],
    },
    'font-weight': {
      value: '300',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '300',
      },
      name: 'DsFontSizeSmFontWeight',
      attributes: {
        category: '-ds-font-size-sm',
        type: 'font-weight',
      },
      path: ['-ds-font-size-sm', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeSmColor',
      attributes: {
        category: '-ds-font-size-sm',
        type: 'color',
      },
      path: ['-ds-font-size-sm', 'color'],
    },
  },
  '-ds-font-size-xl': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Regular'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Regular'",
      },
      name: 'DsFontSizeXlFontFamily',
      attributes: {
        category: '-ds-font-size-xl',
        type: 'font-family',
      },
      path: ['-ds-font-size-xl', 'font-family'],
    },
    'font-size': {
      value: '30px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '30px',
      },
      name: 'DsFontSizeXlFontSize',
      attributes: {
        category: '-ds-font-size-xl',
        type: 'font-size',
      },
      path: ['-ds-font-size-xl', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeXlLetterSpacing',
      attributes: {
        category: '-ds-font-size-xl',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-xl', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeXlLineHeight',
      attributes: {
        category: '-ds-font-size-xl',
        type: 'line-height',
      },
      path: ['-ds-font-size-xl', 'line-height'],
    },
    'font-weight': {
      value: '400',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '400',
      },
      name: 'DsFontSizeXlFontWeight',
      attributes: {
        category: '-ds-font-size-xl',
        type: 'font-weight',
      },
      path: ['-ds-font-size-xl', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeXlColor',
      attributes: {
        category: '-ds-font-size-xl',
        type: 'color',
      },
      path: ['-ds-font-size-xl', 'color'],
    },
  },
  '-ds-font-size-xs': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      },
      name: 'DsFontSizeXsFontFamily',
      attributes: {
        category: '-ds-font-size-xs',
        type: 'font-family',
      },
      path: ['-ds-font-size-xs', 'font-family'],
    },
    'font-size': {
      value: '16px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '16px',
      },
      name: 'DsFontSizeXsFontSize',
      attributes: {
        category: '-ds-font-size-xs',
        type: 'font-size',
      },
      path: ['-ds-font-size-xs', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeXsLetterSpacing',
      attributes: {
        category: '-ds-font-size-xs',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-xs', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeXsLineHeight',
      attributes: {
        category: '-ds-font-size-xs',
        type: 'line-height',
      },
      path: ['-ds-font-size-xs', 'line-height'],
    },
    'font-weight': {
      value: '300',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '300',
      },
      name: 'DsFontSizeXsFontWeight',
      attributes: {
        category: '-ds-font-size-xs',
        type: 'font-weight',
      },
      path: ['-ds-font-size-xs', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeXsColor',
      attributes: {
        category: '-ds-font-size-xs',
        type: 'color',
      },
      path: ['-ds-font-size-xs', 'color'],
    },
  },
  '-ds-font-size-xxl': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Regular'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Regular'",
      },
      name: 'DsFontSizeXxlFontFamily',
      attributes: {
        category: '-ds-font-size-xxl',
        type: 'font-family',
      },
      path: ['-ds-font-size-xxl', 'font-family'],
    },
    'font-size': {
      value: '40px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '40px',
      },
      name: 'DsFontSizeXxlFontSize',
      attributes: {
        category: '-ds-font-size-xxl',
        type: 'font-size',
      },
      path: ['-ds-font-size-xxl', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeXxlLetterSpacing',
      attributes: {
        category: '-ds-font-size-xxl',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-xxl', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeXxlLineHeight',
      attributes: {
        category: '-ds-font-size-xxl',
        type: 'line-height',
      },
      path: ['-ds-font-size-xxl', 'line-height'],
    },
    'font-weight': {
      value: '400',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '400',
      },
      name: 'DsFontSizeXxlFontWeight',
      attributes: {
        category: '-ds-font-size-xxl',
        type: 'font-weight',
      },
      path: ['-ds-font-size-xxl', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeXxlColor',
      attributes: {
        category: '-ds-font-size-xxl',
        type: 'color',
      },
      path: ['-ds-font-size-xxl', 'color'],
    },
  },
  '-ds-font-size-xxs': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      },
      name: 'DsFontSizeXxsFontFamily',
      attributes: {
        category: '-ds-font-size-xxs',
        type: 'font-family',
      },
      path: ['-ds-font-size-xxs', 'font-family'],
    },
    'font-size': {
      value: '14px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '14px',
      },
      name: 'DsFontSizeXxsFontSize',
      attributes: {
        category: '-ds-font-size-xxs',
        type: 'font-size',
      },
      path: ['-ds-font-size-xxs', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeXxsLetterSpacing',
      attributes: {
        category: '-ds-font-size-xxs',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-xxs', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeXxsLineHeight',
      attributes: {
        category: '-ds-font-size-xxs',
        type: 'line-height',
      },
      path: ['-ds-font-size-xxs', 'line-height'],
    },
    'font-weight': {
      value: '300',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '300',
      },
      name: 'DsFontSizeXxsFontWeight',
      attributes: {
        category: '-ds-font-size-xxs',
        type: 'font-weight',
      },
      path: ['-ds-font-size-xxs', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeXxsColor',
      attributes: {
        category: '-ds-font-size-xxs',
        type: 'color',
      },
      path: ['-ds-font-size-xxs', 'color'],
    },
  },
  '-ds-font-size-xxxs': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Light'",
      },
      name: 'DsFontSizeXxxsFontFamily',
      attributes: {
        category: '-ds-font-size-xxxs',
        type: 'font-family',
      },
      path: ['-ds-font-size-xxxs', 'font-family'],
    },
    'font-size': {
      value: '10px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '10px',
      },
      name: 'DsFontSizeXxxsFontSize',
      attributes: {
        category: '-ds-font-size-xxxs',
        type: 'font-size',
      },
      path: ['-ds-font-size-xxxs', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeXxxsLetterSpacing',
      attributes: {
        category: '-ds-font-size-xxxs',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-xxxs', 'letter-spacing'],
    },
    'line-height': {
      value: '100%',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '100%',
      },
      name: 'DsFontSizeXxxsLineHeight',
      attributes: {
        category: '-ds-font-size-xxxs',
        type: 'line-height',
      },
      path: ['-ds-font-size-xxxs', 'line-height'],
    },
    'font-weight': {
      value: '300',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '300',
      },
      name: 'DsFontSizeXxxsFontWeight',
      attributes: {
        category: '-ds-font-size-xxxs',
        type: 'font-weight',
      },
      path: ['-ds-font-size-xxxs', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeXxxsColor',
      attributes: {
        category: '-ds-font-size-xxxs',
        type: 'color',
      },
      path: ['-ds-font-size-xxxs', 'color'],
    },
  },
  '-ds-font-size-xxxl': {
    'font-family': {
      value: "'GT Walsheim Pro', 'GTWalsheimPro-Medium'",
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: "'GT Walsheim Pro', 'GTWalsheimPro-Medium'",
      },
      name: 'DsFontSizeXxxlFontFamily',
      attributes: {
        category: '-ds-font-size-xxxl',
        type: 'font-family',
      },
      path: ['-ds-font-size-xxxl', 'font-family'],
    },
    'font-size': {
      value: '64px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '64px',
      },
      name: 'DsFontSizeXxxlFontSize',
      attributes: {
        category: '-ds-font-size-xxxl',
        type: 'font-size',
      },
      path: ['-ds-font-size-xxxl', 'font-size'],
    },
    'letter-spacing': {
      value: '0px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '0px',
      },
      name: 'DsFontSizeXxxlLetterSpacing',
      attributes: {
        category: '-ds-font-size-xxxl',
        type: 'letter-spacing',
      },
      path: ['-ds-font-size-xxxl', 'letter-spacing'],
    },
    'line-height': {
      value: '64px',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '64px',
      },
      name: 'DsFontSizeXxxlLineHeight',
      attributes: {
        category: '-ds-font-size-xxxl',
        type: 'line-height',
      },
      path: ['-ds-font-size-xxxl', 'line-height'],
    },
    'font-weight': {
      value: '500',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: '500',
      },
      name: 'DsFontSizeXxxlFontWeight',
      attributes: {
        category: '-ds-font-size-xxxl',
        type: 'font-weight',
      },
      path: ['-ds-font-size-xxxl', 'font-weight'],
    },
    color: {
      value: 'black',
      filePath: './style-dictionary/tokens/token.json',
      isSource: true,
      original: {
        value: 'black',
      },
      name: 'DsFontSizeXxxlColor',
      attributes: {
        category: '-ds-font-size-xxxl',
        type: 'color',
      },
      path: ['-ds-font-size-xxxl', 'color'],
    },
  },
}
